import gql from 'graphql-tag';
const QUOTE_BUBBLE_ACTIVITY_FRAGMENT = gql `
  fragment QuoteBubbleActivityFragment on QuoteBubbleActivity {
    rounds {
      id
      quote
      word
      meaning
      paragraph
      leftImage {
        id
        image {
          description
          id
          src
        }
      }
      centerImage {
        id
        image {
          description
          id
          src
        }
      }
    }
  }
`;
export default QUOTE_BUBBLE_ACTIVITY_FRAGMENT;
